export default __webpack_public_path__ + "static/media/call-center-signin.9bf677a6.png";